/**
 * @GENERATED from Figma node 778:10116
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const GoogleCalendarBright = (
  props: IconProps,
  ref: React.Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#1E88E5"
      d="m12.95 10.278.573.817.883-.64v4.636h.95V8.998h-.795zM11.426 11.868A1.7 1.7 0 0 0 12 10.609c0-.971-.86-1.766-1.898-1.766-.883 0-1.656.552-1.855 1.369l.927.243c.089-.376.486-.64.928-.64.53 0 .949.353.949.794s-.42.795-.95.795H9.55v.971h.552c.596 0 1.103.42 1.103.905 0 .508-.485.905-1.081.905-.53 0-.994-.33-1.06-.794l-.927.154c.154.905 1.015 1.59 2.009 1.59 1.125 0 2.03-.84 2.03-1.877a1.85 1.85 0 0 0-.75-1.39"
    />
    <path fill="#FBC02D" d="M17.585 22H6.459v-4.437h11.126z" />
    <path fill="#4CAF50" d="M22.022 17.563V6.437h-4.437v11.126z" />
    <path
      fill="#1E88E5"
      d="M17.585 6.437V2H3.678C2.75 2 2 2.75 2 3.678v13.907h4.437V6.437z"
    />
    <path fill="#E53935" d="M17.585 17.563V22l4.437-4.437z" />
    <path
      fill="#1565C0"
      d="M20.367 2h-2.782v4.437h4.437V3.656A1.64 1.64 0 0 0 20.367 2M3.678 22h2.781v-4.437H2.022v2.781A1.64 1.64 0 0 0 3.678 22"
    />
  </svg>
);
const ForwardRef = React.forwardRef(GoogleCalendarBright);
export { ForwardRef as GoogleCalendarBright };
